<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="450px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template v-if="isNewCarrierLabel">
                        Tworzenie etykiety kurierskiej
                    </template>
                    <template v-else>
                        Wydruk etykiety kurierskiej
                    </template>
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-row>
                    <v-col cols="12">
                        <v-select
                            v-model="carrierLabel.shippingLabelTemplateId"
                            label="Szablon etykiety"
                            :items="templates"
                            item-value="shippingLabelTemplateId"
                            item-text="carrierName"
                            no-data-text="Nie znaleziono szablonów"
                            outlined
                            clearable
                            dense
                            :disabled="!isNewCarrierLabel"
                            :error-messages="shippingLabelTemplateIdErrors"
                        />
                        <v-menu
                            v-model="datePicker"
                            transition="scale-transition"
                            bottom
                            nudge-bottom="40"
                            nudge-right="34"
                            min-width="290px"
                        >
                            <template #activator="{on}">
                                <v-text-field
                                    :value="formatDate(carrierLabel.sendDate, false, false)"
                                    label="Data wysyłki"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    clearable
                                    outlined
                                    dense
                                    :disabled="!isNewCarrierLabel"
                                    :error-messages="sendDateErrors"
                                    v-on="on"
                                    @click:clear="clearSendDate"
                                />
                            </template>
                            <v-date-picker
                                :value="carrierLabel.sendDate"
                                no-title
                                scrollable
                                first-day-of-week="1"
                                @input="sendDateHandler"
                            />
                        </v-menu>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    :disabled="actionLoading"
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Drukuj"
                    :loading="actionLoading"
                    @click="onSave"
                >
                    <template>
                        Drukuj
                    </template>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import dateFormatter from '@/mixins/dateFormatter'
import { required } from 'vuelidate/lib/validators'
import { isEmpty } from 'lodash'
import { format } from 'date-fns'

const carriersTemplates = [
    {
        'carrierName': 'DPD',
        'shippingLabelTemplateId': 5
    },
    {
        'carrierName': 'GLS',
        'shippingLabelTemplateId': 7
    },
    {
        'carrierName': 'GLS Czechy',
        'shippingLabelTemplateId': 6
    },
    {
        'carrierName': 'WMD',
        'shippingLabelTemplateId': 13
    },
    {
        'carrierName': 'DPD zbiorcza',
        'shippingLabelTemplateId': 15
    },
]

export default {
    name: 'CarrierLabelDialog',
    mixins: [
        dateFormatter
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        carrierLabelData: {
            type: Object,
            default: () => {}
        },
        actionLoading: {
            type: Boolean
        }
    },
    data() {
        return {
            carrierLabel: {
                shippingLabelTemplateId: null,
                sendDate: format(new Date(), 'YYYY-MM-DD'),
                shippingLabelId: null
            },
            datePicker: false
        }
    },
    validations: {
        carrierLabel: {
            shippingLabelTemplateId: {
                required
            },
            sendDate: {
                required

            }
        }
    },
    computed: {
        templates() {
            return carriersTemplates
        },
        isNewCarrierLabel() {
            return isEmpty(this.carrierLabelData)
        },
        shippingLabelTemplateIdErrors() {
            const errors = []

            if (!this.$v.carrierLabel.shippingLabelTemplateId.$dirty) return errors

            if (!this.$v.carrierLabel.shippingLabelTemplateId.required) {
                errors.push('Szablon jest wymagany')
            }

            return errors
        },
        sendDateErrors() {
            const errors = []

            if (!this.$v.carrierLabel.sendDate.$dirty) return errors
            !this.$v.carrierLabel.sendDate.required && errors.push('Proszę wybrać datę wysyłki.')

            return errors
        },
    },
    watch: {
        isOpen(boolean) {
            if ((boolean)) {
                if (!isEmpty(this.carrierLabelData)) {
                    this.carrierLabel = JSON.parse(JSON.stringify(this.carrierLabelData))
                    this.carrierLabel.shippingLabelId = this.carrierLabel.id
                }
            } else {
                setTimeout(() => {
                    this.$v.$reset()
                    this.carrierLabel = {}
                    this.carrierLabel.shippingLabelTemplateId = null
                    this.carrierLabel.sendDate = format(new Date(), 'YYYY-MM-DD')
                    this.carrierLabel.shippingLabelId = null
                }, 500)
            }
        }
    },
    methods: {
        clearSendDate() {
            this.carrierLabel.sendDate = null
        },
        sendDateHandler(date) {
            this.carrierLabel.sendDate = date
        },
        onSave() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }
            if (this.isNewCarrierLabel) {
                this.$emit('on-submit', this.carrierLabel)
            } else {
                this.$emit('on-print', this.carrierLabel)
            }
        },
        onClose() {
            this.$v.$reset()
            this.$emit('on-close')
        },
    }
}
</script>